import { workflowsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useDisableWorkflow = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    workflowsRepo.disableWorkflow(id),
  );
